module.exports = __webpack_public_path__ + "img/bf345b7.svg";